import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {HeightCalcWrapper} from '../../../features/HeightCalcWrapper/HeightCalcWrapper';
import {useGetGenderedCards} from '../utils/useGetGenderedCards';
import {CardsSliderLoading} from './CardsSliderLoading';
import {CardsSliderView, CardsSliderViewProps} from './CardsSliderView';

export const CardsSlider: React.FC<CardsSliderViewProps> = props => {
  return (
    <HeightCalcWrapper>
      <DataFetcher
        request={useGetGenderedCards()}
        Error={null}
        Loading={CardsSliderLoading}
        View={CardsSliderView}
        viewProps={props}
      />
    </HeightCalcWrapper>
  );
};
